const BASE64_IMAGE_TAG_REGEX = /<img\b[^>]*\bsrc=(['"])data:image\/[^'"]+\1[^>]*>/gi;

export const containsBase64Image = (html = "") =>
  typeof html === "string" &&
  /<img\b[^>]*\bsrc=(['"])data:image\/[^'"]+\1[^>]*>/i.test(html);

export const stripBase64Images = (html = "") => {
  if (typeof html !== "string") {
    return html;
  }

  return html.replace(BASE64_IMAGE_TAG_REGEX, "");
};

export const clipboardHasImage = (event) =>
  Array.from(event?.clipboardData?.items || []).some((item) =>
    item?.type?.startsWith("image/")
  );
